import { render, staticRenderFns } from "./Reno.vue?vue&type=template&id=4008b252&scoped=true"
import script from "./Reno.vue?vue&type=script&lang=js"
export * from "./Reno.vue?vue&type=script&lang=js"
import style0 from "./Reno.vue?vue&type=style&index=0&id=4008b252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4008b252",
  null
  
)

export default component.exports